// extracted by mini-css-extract-plugin
export var compactFilters = "_d3-4";
export var detailImage = "_d3-1";
export var dropdownContainer = "_d3-2";
export var imageContainer = "_d3-0";
export var selectedCard = "_d3-3";